import { render, staticRenderFns } from "./UploadDocuments.vue?vue&type=template&id=0878c8ba"
import script from "./UploadDocuments.vue?vue&type=script&lang=ts"
export * from "./UploadDocuments.vue?vue&type=script&lang=ts"
import style0 from "./UploadDocuments.vue?vue&type=style&index=0&id=0878c8ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports